import { getCustomerToken } from "./jwtService";

// @Utility
import { getStorage } from "@utility/app/storage";

let customerToken = getCustomerToken();
if (customerToken === null) {
  customerToken = getStorage("generalToken");
}

const data = {
  loginEndpoint: "/auth/login-username",
  loginTokenEndpoint: "/auth/login-token",
  registerEndpoint: "/auth/register-option",
  registerEndpointShort: "/auth/register-short",
  refreshEndpoint: "/app/refresh-token",
  logoutEndpoint: "/auth/logout",
  loginLine: "/auth/login-line",
  checkUsername: "/auth/check-username",
  checkBankAccount: "/auth/check-bank-account",
  checkAccount: "/auth/check-account",
  refreshToken: "/customer/generate/refresh-token",
  generalTokenEndpoint: "/auth/login-general",
  rememberPassword: "/auth/reset-password",
  tokenName: "customerToken",
  headerType: 'Bearer',
  contentType: "application/x-www-form-urlencoded",
  method_get: "get",
  method_post: "post",
  method_put: "put"
};

export default data;
